// @flow
import React, { Component } from 'react'
import _ from 'lodash'
import styled, { type StyledComponent } from 'styled-components'
import Button from '../../controls/PrimaryButton'
import MultiSelect from '../../controls/MultiSelect'
import Select from '../../controls/Select'
import type { OptionType, VkEventGroup, VkEventSources } from '../../types'
import shortId from 'shortid'
import postJson from '../../../services/postJson'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  width: 660px;
  padding-top: 10px;
`
const InputGroupsWrapper: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 12px;
  margin-left: -5px;
`
const InputGroup: StyledComponent<Object, any, any> = styled.div`
  font-size: 14px;
  width: 220px;
  padding-left: 5px;
`
const StyledLabel: StyledComponent<Object, any, any> = styled.div`
  padding: 3px 0;
  font-size: 12px;
  color: gray;
`
const ButtonWrapper: StyledComponent<Object, any, any> = styled.div`
  padding-bottom: 10px;
`
const StyledInput: StyledComponent<Object, any, any> = styled.input`
  width: 100%;
`

type Props = {|
  vkEventSources: VkEventSources,
  vkEventOptions: Array<OptionType>,
  vkEventGroups: Array<VkEventGroup>,
  onChange: Function,
  onClose: Function
|}

type State = {|
  vkEventGroups: Array<VkEventGroup>,
  isLoading: boolean
|}

const t = {
  add: 'Добавить',
  apply: 'Применить',
  event_select_label: 'Выбор события',
  placeholder: 'Выберите',
  source_select_label: 'Выбор сегмента',
  promopost_view: 'Просмотр промопоста',
  link_visit: 'Переход по ссылке или в сообщество',
  group_visit: 'Переход в сообщество',
  group_join: 'Подписка на сообщество',
  group_leave: 'Отписка от новостей сообщества',
  hide: 'Скрытие или жалоба',
  like: 'Лайк',
  repost: 'Репост',
  all_positive: 'Все позитивные',
  all_negative: 'Все негативные',
  new_segment: 'Создать новый сегмент',
  segment_name_label: 'Название сегмента'
}

const SEGMENTS_URL = '/api/v1/segments'

export default class VkEventForm extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      vkEventGroups: props.vkEventGroups,
      isLoading: false
    }
  }

  render() {
    const { vkEventSources } = this.props
    const { vkEventGroups, isLoading } = this.state
    const sourcesOptions = this.sourcesOptions()
    return (
      <Wrapper>
        {_.map(vkEventGroups, (eventGroup, index: number) => {
          return (
            <InputGroupsWrapper key={index}>
              <InputGroup className={`t-VkEventSourceSelect_${index}`}>
                <StyledLabel>{t.source_select_label}</StyledLabel>
                <Select
                  value={this.sourcesValue(eventGroup, sourcesOptions)}
                  placeholder={t.placeholder}
                  options={sourcesOptions}
                  disabled={isLoading}
                  onChange={(id) => {
                    const newGroup = {
                      id: eventGroup.id,
                      sourceType: id === 'new_segment' ? 'segment' : vkEventSources[id].type,
                      sourceId: id === 'new_segment' ? null : vkEventSources[id].id,
                      sourceName: id === 'new_segment' ? '' : vkEventSources[id].name,
                      eventTypes: eventGroup.eventTypes
                    }
                    this.updateVkEventGroups(eventGroup, newGroup)
                  }}
                />
              </InputGroup>
              {!eventGroup.sourceId && (
                <InputGroup className={`t-VkEventNewSegmentName_${index}`}>
                  <StyledLabel>{t.segment_name_label}</StyledLabel>
                  <StyledInput
                    type="text"
                    className="input-item"
                    value={eventGroup.sourceName}
                    disabled={isLoading}
                    onChange={(e) => {
                      const newGroup = {
                        id: eventGroup.id,
                        sourceType: eventGroup.sourceType,
                        sourceId: null,
                        sourceName: e.target.value,
                        eventTypes: eventGroup.eventTypes
                      }
                      this.updateVkEventGroups(eventGroup, newGroup)
                    }}
                  />
                </InputGroup>
              )}
              <InputGroup className={`t-VkEventTypeSelect_${index}`}>
                <StyledLabel>{t.event_select_label}</StyledLabel>
                <MultiSelect
                  value={eventGroup.eventTypes}
                  placeholder={t.placeholder}
                  options={_.map(this.props.vkEventOptions, (option) => {
                    return { id: option.id, name: t[option.name] }
                  })}
                  disabled={isLoading}
                  onChange={(values) => {
                    const newGroup = {
                      id: eventGroup.id,
                      sourceId: eventGroup.sourceId,
                      sourceType: eventGroup.sourceType,
                      sourceName: eventGroup.sourceName,
                      eventTypes: values
                    }
                    this.updateVkEventGroups(eventGroup, newGroup)
                  }}
                />
              </InputGroup>
            </InputGroupsWrapper>
          )
        })}
        <ButtonWrapper>
          <Button
            small
            disabled={isLoading}
            onClick={(e) => {
              e.preventDefault()
              this.setState({
                vkEventGroups: [...vkEventGroups, this.defaultEventGroup(sourcesOptions)]
              })
            }}
          >
            {t.add}
          </Button>
        </ButtonWrapper>
        <ButtonWrapper>
          <Button
            small
            disabled={isLoading}
            onClick={(e) => {
              e.preventDefault()
              this.createNewSegments()
            }}
          >
            {t.apply}
          </Button>
        </ButtonWrapper>
      </Wrapper>
    )
  }

  defaultEventGroup(sourcesOptions: Array<OptionType>) {
    const { vkEventSources } = this.props
    const firstOption = _.first(sourcesOptions)
    if (_.isEmpty(vkEventSources))
      return { sourceId: null, sourceType: 'segment', sourceName: '', eventTypes: [] }
    return {
      sourceId: vkEventSources[firstOption.id].id,
      sourceType: vkEventSources[firstOption.id].type,
      sourceName: vkEventSources[firstOption.id].name,
      eventTypes: []
    }
  }

  sourcesValue(eventGroup: VkEventGroup, sourcesOptions: Array<OptionType>): string {
    const { vkEventSources } = this.props
    let source = _.pickBy(vkEventSources, (source) => {
      const sourceObject = { id: source.id, name: source.name, type: source.type }
      const eventGroupObject = {
        id: eventGroup.sourceId,
        name: eventGroup.sourceName,
        type: eventGroup.sourceType
      }
      return _.isEqual(sourceObject, eventGroupObject)
    })
    return _.isEmpty(source) ? _.first(sourcesOptions).id : _.first(_.keys(source))
  }

  sourcesOptions(): Array<OptionType> {
    const { vkEventSources } = this.props
    const vkEventSourcesOptions = _.map(vkEventSources, (source, id: string) => {
      return { id: id, name: source.name }
    })
    return _.concat(vkEventSourcesOptions, { id: 'new_segment', name: t.new_segment })
  }

  updateVkEventGroups(oldGroup: VkEventGroup, newGroup: VkEventGroup) {
    let vkEventGroups = this.state.vkEventGroups
    const index = _.indexOf(vkEventGroups, oldGroup)
    vkEventGroups.splice(index, 0, newGroup)
    this.setState({ vkEventGroups: _.without(vkEventGroups, oldGroup) })
  }

  createNewSegments() {
    const { onChange, onClose } = this.props
    const { vkEventGroups } = this.state
    const groupSegmentsToCreate = _.filter(vkEventGroups, (eventGroup) => {
      return !eventGroup.sourceId
    })
    if (_.isEmpty(groupSegmentsToCreate)) {
      onChange({ vkEventGroups })
      onClose()
      return
    }
    this.setState(
      { isLoading: true, vkEventGroups: _.without(vkEventGroups, ...groupSegmentsToCreate) },
      () => {
        Promise.all(
          _.map(groupSegmentsToCreate, (eventGroup) => {
            return this.createNewSegment(eventGroup)
          })
        ).then(
          (newSegmentGroups) => {
            this.addNewSegmentGroupsToSourcesAndEventGroups(newSegmentGroups)
            this.setState({ isLoading: false })
            onClose()
          },
          (reason) => {
            console.log(reason)
            window.alert('Internal error')
            this.setState({ isLoading: false })
          }
        )
      }
    )
  }

  createNewSegment(eventGroup: VkEventGroup) {
    return new Promise<any>((resolve, reject) => {
      postJson(SEGMENTS_URL, { segment: { name: eventGroup.sourceName, without_domain: true } })
        .done((response) => {
          resolve({ ...eventGroup, sourceId: response.data.id })
        })
        .fail((response) => reject(response))
    })
  }

  addNewSegmentGroupsToSourcesAndEventGroups(newSegmentGroups: Array<VkEventGroup>) {
    const { vkEventSources, onChange } = this.props
    const { vkEventGroups } = this.state
    if (_.isEmpty(newSegmentGroups)) return
    let newSources = {}
    _.each(newSegmentGroups, (group) => {
      newSources[shortId.generate()] = {
        id: group.sourceId,
        type: group.sourceType,
        name: group.sourceName
      }
    })
    onChange({
      vkEventSources: { ...vkEventSources, ...newSources },
      vkEventGroups: _.concat(vkEventGroups, newSegmentGroups)
    })
  }
}
